var _defs, _polygon, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffordabilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d4b35f;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "405.48 542.66 54.74 542.66 54.74 211.58 169.58 102.46 290.64 102.46 372.56 180.3 365.67 187.55 286.65 112.46 173.58 112.46 64.74 215.88 64.74 532.66 395.48 532.66 395.48 304.46 405.48 304.46 405.48 542.66"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.33,437.59c-2.76,0-5-2.24-5-5v-82.21c0-30.91,25.15-56.06,56.06-56.06,13.88,0,27.2,5.11,37.51,14.4,2.05,1.85,2.22,5.01.37,7.06-1.85,2.05-5.01,2.22-7.06.37-8.47-7.62-19.41-11.83-30.82-11.83-25.4,0-46.06,20.66-46.06,46.06v82.21c0,2.76-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275,380.2h-100.33c-2.76,0-5-2.24-5-5s2.24-5,5-5h100.33c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.55,439.6h-110.88c-2.76,0-5-2.24-5-5s2.24-5,5-5h110.88c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.11,208.03c-16.48,0-29.89-13.41-29.89-29.89s13.41-29.89,29.89-29.89,29.89,13.41,29.89,29.89-13.41,29.89-29.89,29.89ZM230.11,158.24c-10.97,0-19.89,8.92-19.89,19.89s8.92,19.89,19.89,19.89,19.89-8.92,19.89-19.89-8.92-19.89-19.89-19.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.79,346.62c-1.53,0-2.98-.7-3.93-1.9l-110.47-140.03c-1.19-1.5-1.41-3.55-.57-5.28.84-1.72,2.58-2.82,4.5-2.82h44.79V62.34c0-2.76,2.24-5,5-5h119.8c2.76,0,5,2.24,5,5v134.25h46.34c1.92,0,3.66,1.09,4.5,2.82.84,1.72.61,3.77-.57,5.28l-110.47,140.03c-.95,1.2-2.39,1.9-3.93,1.9ZM329.64,206.59l100.15,126.95,100.15-126.95h-41.03c-2.76,0-5-2.24-5-5V67.34h-109.8v134.25c0,2.76-2.24,5-5,5h-39.47Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffordabilityIcon);
export default __webpack_public_path__ + "static/media/AffordabilityIcon.261cd41ef7303745292edb85a8f0189d.svg";
export { ForwardRef as ReactComponent };